var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-list-group',_vm._l((_vm.list),function(item){return _c('b-list-group-item',{attrs:{"active":item === _vm.activeConfig,"to":{name: 'PredictionConfig', params:{configId: item}}}},[_vm._v(_vm._s(item))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }